<div class="buy-sucess">
  <div id="buy-sucess__header" class="buy-sucess__header">
    <span>
      <img
        src="assets/RA LOGO-01.svg"
        class="buy-sucess__header__logo"
        routerLink=""
      />
    </span>
  </div>
  <div class="buy-sucess__content">
    <div class="buy-sucess__content__header">
      <h2 class="buy-sucess__content__header--head">Payment Successful</h2>
      <span class="buy-sucess__content__header--sub"
        >You will receive an email shortly from us to set up a password to login
        to the application. If you do not receive any email please contact at
        <a href="mailto:info@ravisacademy.com">info@ravisacademy.com</a></span
      >
    </div>
  </div>
</div>
